// extracted by mini-css-extract-plugin
var _1 = "ColorOption_root__b4fa6";
export { _1 as "root" }
